var map = {
	"./add.svg": 224,
	"./arrowDown.svg": 114,
	"./arrowUp.svg": 115,
	"./br.svg": 225,
	"./camera.svg": 226,
	"./copy.svg": 227,
	"./delete.svg": 228,
	"./done.svg": 229,
	"./en.svg": 230,
	"./es.svg": 231,
	"./faceFrame.svg": 232,
	"./face_overlay.svg": 233,
	"./restart.svg": 234,
	"./settings-white.svg": 235,
	"./success.svg": 236,
	"./take_photo.svg": 237,
	"./translate.svg": 116,
	"./us.svg": 238,
	"./values.svg": 239,
	"./white-camera.svg": 240,
	"./white-check.svg": 241,
	"./white-restart.svg": 242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223;